export const optionsDrinking = [
  "Não bebo",
  "Socialmente",
  "Regularmente",
  "Excessivamente",
];
